<template>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  
    <div class="main_wrapper ion-padding">
        <div class="subscription-title">Subscription Details</div>
        <div v-if="subscription" class="card">
            <div>
                <div class="benefit-title">
                    Subscription type: {{ user.subscribedInfos.subscription.name}}
                </div>
                <div class="subscription-date">
                    <div class="subscription-date-start">Started Date:  {{ formatDate(user.subscribedInfos.subscriptionStartDate) }} </div>
                    <div class="subscription-date-end">Renewal Date: {{ formatDate(user.subscribedInfos.subscriptionRenewalDate) }} </div>
                </div>
              
              <div class="benefit-title">
                * Free Shifts
              </div>
              <div>{{ remainingSubscriptions }} out of {{ totalSubscriptions }}</div>
              <div class="progress">
                <div class="bar" :style="{ width: progressBarWidth, backgroundColor: barColor }">
               
                </div>
              </div>
              <div class="benefits">
                <div class="benefit-box">
                  <div class="benefit-title">Transaction Fee</div>
                  <div class="benefit-info">{{transactionSubPrice}}% ({{transactionOriginalPrice}}% without subscription)</div>
                </div>
                <div class="benefit-box">
                  <div class="benefit-title">Booking Fee</div>
                  <div class="benefit-info">{{ currencyFormat(bookingSubPrice) }}</div>
                </div>
                <div class="benefit-box">
                  <div class="benefit-title">Price</div>
                  <div class="benefit-info">{{  currencyFormat(user.subscribedInfos.subscription.monthlyPrice) }} </div>
                </div>
              </div>

              <!-- <div class="benefits">
                
                <div v-if="user.role !== 'pharmacy'" class="benefit-box">
                  <div class="benefit-title">Seats Available</div>
                  <div class="benefit-info">{{ user.subscribedInfos.availableSeats }}</div>
                </div>
              </div> -->

             
            </div>
            <div>
                <div class="text"></div>
            </div>
            </div>
        </div>
  </template>
  
  <script>
  import {
    // ref,
    // reactive,
    onMounted,
    inject,
    ref,
    computed
  } from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
  
  import { useStore } from "vuex";
  
  import {
    useRouter,
    // useRoute
  } from "vue-router";
  
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
    },
    directives: {},
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const $moment = inject(["$moment"]);
      // const $route = useRoute()
      const setPageClassGlobal = inject("setPageClassGlobal");
      const mainMenuShow = inject("mainMenuShow");
  
      const user = $store.getters.GET_USER_DATA;
      console.log("🚀 ~ file: Subscription.vue:81 ~ setup ~ user:", user)
      const subscription = ref(user.calculatedSubscriptions.subscription?user.calculatedSubscriptions.subscription:0);
      const totalSubscriptions = ref(user.calculatedSubscriptions.totalSubscriptions?user.calculatedSubscriptions.totalSubscriptions:0);
      const remainingSubscriptions = ref(user.calculatedSubscriptions.remainingSubscriptions? user.calculatedSubscriptions.remainingSubscriptions :0);
      const transactionOriginalPrice = ref(user.calculatedSubscriptions.transactionOriginalPrice? user.calculatedSubscriptions.transactionOriginalPrice : 0);
      const transactionSubPrice = ref(user.calculatedSubscriptions.transactionSubPrice? user.calculatedSubscriptions.transactionSubPrice : 0);
      const bookingSubPrice = ref(user.calculatedSubscriptions.bookingSubPrice?user.calculatedSubscriptions.bookingSubPrice:0);
    //   const subscriptionDetais = ref(userAgent.subscribedInfos);

      const progressBarWidth = computed(() => {
      const percentage = (remainingSubscriptions.value / totalSubscriptions.value) * 100;
      return `${percentage}%`;
    });

    const currencyFormat = (value) => {
      return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(value);
    };

    const barColor = computed(() => {
      // Define your desired bar color logic here
      return '#2463FF';
    });

    const formatDate = (dateString) => {
      const date = $moment(dateString);
      return date.format('D MMM, YYYY'); // Adjust the format as needed
    };
  
      const goBack = () => {
        $router.push({
          name: "profile",
        });
      };
  
      onMounted(() => {
        setPageClassGlobal("global_subscription_page");
        mainMenuShow(true);
      });
  
      return {
        user,
        goBack,
        subscription,
        totalSubscriptions,
        remainingSubscriptions,
        transactionOriginalPrice,
        transactionSubPrice,
        bookingSubPrice,
        progressBarWidth,
        barColor,
        formatDate,
        currencyFormat,
      };
    },
  };
  </script>
  